import ngRedux from 'ng-redux';
import { Action as ActionBase } from 'redux';
import thunk from 'redux-thunk';
import { ThunkAction } from 'redux-thunk';

export type INgReduxProvider = ngRedux.INgReduxProvider;
export type INgRedux = ngRedux.INgRedux;
export type Dispatch = ngRedux.Dispatch;
export type Action = ActionBase<string>;
export type ThunkResult<S, A extends Action> = ThunkAction<void, S, {}, A>;

export { Reducer, combineReducers } from 'redux';

export const middleware = [thunk];

// Activate redux tools if we can
const host = window as any;
const factory = host.__REDUX_DEVTOOLS_EXTENSION__;
const devTools = factory ? [factory()] : [];

export const enhancers = [...devTools];
